const defaultConfig = {
  // control pagination from server or in static source
  paginate: {
    page: 1,
    limit: 30,
    sort: null,
  },
  // sorting fields in table
  field_order: [],
  // define behaviors of column
  column_map: {},
  // define how many field visible
  visibility: [],
  // define how many field can sort
  sorting: [],
}

// default a column object
const defaultColumnObject = slug => {
  return {
    key: slug,
    label: slug,
    desc: null,
    request_field: slug,
    sorting_field: null,
    // for graphql
    graph_query: true,
    graph_field: null,
    format: 'TEXT',
    // values: L | R | C
    align: 'L',
    // make width smallest it can
    narrow: false,
    includes: [],
    format_data: {},
  }
}

// build a object control whole dataset
export const initialize = customConfig => {
  //console.log(customConfig)
  // first should merge default config with customer config
  const config = normalizeConfig(defaultConfig, customConfig)
  return Object.assign({}, config)
}

// create list column visible follow column order
export const getColumnInOrder = config => {
  const { visibility, sorting, field_order, column_map } = config
  const columns = []

  const toColumnObj = (list, key) => {
    // not resolve hidden column
    // if (visibility.includes(key) === false) return list
    // resolve visible column
    const colObj = Object.assign({}, column_map[key], {
      visible: visibility.includes(key),
      sortable: sorting.includes(key),
    })
    list.push(colObj)
    return list
  }

  return field_order.reduce(toColumnObj, columns)
}

// - normalize config from default and custom config
const normalizeConfig = (def, cus) => {
  // merge from lv2
  const paginate = Object.assign({}, def.paginate, cus.paginate)

  // normalize sorting
  // because we will have to check double when want know what field sorted
  if (paginate.sort == null) paginate.sort = { field: null, order: 'ASC' }
  if (paginate.limit == null) paginate.limit = 20
  if (paginate.page == null) paginate.page = 1

  const column_map = {}

  const mergeObj = key => {
    const obj = Object.assign({}, defaultColumnObject(key), cus.column_map[key])
    // pre style
    const pre_style = {}
    // align text
    pre_style.textAlign = getStyleTextAlign(obj.align)
    obj.pre_style = pre_style
    // narrow width
    if (obj.narrow) {
      pre_style.whiteSpace = 'nowrap'
      pre_style.width = '1%'
    }

    return (column_map[key] = obj)
  }

  Object.keys(cus.column_map).map(mergeObj)

  const field_order = Array.isArray(cus.column_order)
    ? cus.column_order
    : Object.keys(column_map)

  const visibility = Array.isArray(cus.visibility) ? cus.visibility : []

  const sorting = Array.isArray(cus.sorting) ? cus.sorting : []

  const source = cus.source
  const source_type = cus.source_type || 'FILE'

  return {
    paginate,
    column_map,
    field_order,
    visibility,
    sorting,
    source,
    source_type,
    data: null,
    total: 0,
  }
}

const getStyleTextAlign = align => {
  if (align === 'L') return 'left'
  if (align === 'R') return 'right'
  if (align === 'C') return 'center'
  return 'left'
}
